<footer class="bg-black text-white">
  <div class="contain mx-auto py-4 flex gap-4 md:gap-8 flex-col xl:gap-0 xl:flex-row justify-between items-center">
    <div class="flex gap-4 md:gap-8 items-center">
      <a href="https://x.com/cityzmedia" target="_blank">
        <img src="assets/images/x.svg" alt="X" class="w-5 h-5">
      </a>
      <a href="https://www.facebook.com/cityzmedia" target="_blank">
        <img src="assets/images/facebook.svg" alt="Facebook" class="w-5 h-5">
      </a>
      <a href="https://www.linkedin.com/company/cityzmedia/" target="_blank">
        <img src="assets/images/linkedin.svg" alt="Linkedin" class="w-5 h-5">
      </a>
      <a href="https://www.youtube.com/@cityzmedia" target="_blank">
        <img src="assets/images/youtube.svg" alt="Youtube" class="w-5 h-5">
      </a>
      <a href="https://www.instagram.com/cityzmedia/" target="_blank">
        <img src="assets/images/instagram.svg" alt="Instagram" class="w-5 h-5">
      </a>
    </div>
    <div class="flex gap-4 justify-center items-center text-xs whitespace-nowrap flex-wrap">
      <p>©2025 - 2026 Cityz</p>
      <p>v{{ appVersion }}</p>
      <a href="https://www.cityzmedia.fr/mentions-legales/" target="_blank">Mentions légales</a>
      <a href="https://www.cityzmedia.fr/conditions-generales-de-vente/" target="_blank">CGV</a>
      <a href="https://www.cityzmedia.fr/conditions-generales-dachat/" target="_blank">CGA</a>
      <a href="https://www.cityzmedia.fr/politique-de-confidentialite/" target="_blank">Politiques de confidentialité</a>
      <a href="https://www.cityzmedia.fr/politique-de-conformite/" target="_blank">Politique de conformité</a>
      <a href="https://www.cityzmedia.fr/signalement-de-preoccupations-serieuses/" target="_blank">Signalement</a>
      <a href="https://agileinteractive.fr/" target="_blank">Web app par Agile Interactive</a>
    </div>
  </div>
</footer>
